import classNames from "classnames";
import Icon from "~/components/shared/Icon";

export type AnnotationStyle = "DEFAULT" | "SUCCESS" | "ERROR" | "INFO" | "WARNING";

const ANNOTATION_STYLES: Record<
  AnnotationStyle,
  {
    annotationClass: string;
    icon: string;
  }
> = {
  DEFAULT: {
    annotationClass: "build-annotation-default",
    icon: "heroicons/outline/pencil",
  },
  SUCCESS: {
    annotationClass: "build-annotation-success",
    icon: "check-large",
  },
  ERROR: {
    annotationClass: "build-annotation-error",
    icon: "heroicons/16/solid/x-mark",
  },
  INFO: {
    annotationClass: "build-annotation-info",
    icon: "heroicons/outline/information-circle",
  },
  WARNING: {
    annotationClass: "build-annotation-warning",
    icon: "heroicons/16/solid/exclamation-triangle",
  },
};

type Props = {
  annotation: {
    context: string;
    style: AnnotationStyle;
    body: {
      html: string | null | undefined;
    };
  };
};

export default function Annnotation({ annotation }: Props) {
  const annotationId = `annotation-${annotation.context}`;

  const styles = ANNOTATION_STYLES[annotation.style];

  return (
    <div
      id={annotationId}
      className={classNames(
        `build-annotation mb-2 flex items-stretch rounded border bg-white`,
        styles?.annotationClass,
      )}
    >
      <a
        href={`#${annotationId}`}
        className="annotation-link flex shrink-0 items-start border-r py-4"
      >
        <Icon icon={styles?.icon} className="annotation-icon mt-[2px] h-4 w-4 min-w-0 flex-auto" />
      </a>
      <div className="min-w-0 flex-auto">
        <div
          className="annotation-body m-4"
          dangerouslySetInnerHTML={{
            __html: annotation.body && annotation.body.html ? annotation.body.html : "",
          }}
        />
      </div>
    </div>
  );
}
